export default {
    name: 'v5-icon-heart-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M669.781 130.752c71.638-11.093 138.902 11.477 193.344 64.533 55.318 53.931 81.835 124.992 74.283 199.531-7.467 73.643-46.55 146.368-112.32 210.475-18.347 17.898-67.67 66.218-138.453 135.637-31.83 31.232-65.707 64.448-99.84 97.984L553.6 871.467l-13.184 12.949a40.555 40.555 0 01-56.832 0l-114.603-112.64-24.213-23.723a677626.347 677626.347 0 00-145.856-142.762C133.142 541.184 94.08 468.48 86.613 394.816c-7.552-74.539 18.944-145.6 74.283-199.53 54.443-53.057 121.707-75.606 193.344-64.534 53.163 8.213 107.093 34.688 157.781 76.95 50.71-42.24 104.619-68.737 157.782-76.95z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
